/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViewBlueprintDetails {
    getFixupPrototypeFunction() { return ViewBlueprintDetails.fixupPrototype; }

    static newInstance(model: Partial<ViewBlueprintDetails>): ViewBlueprintDetails {
        let obj = Object.assign(new ViewBlueprintDetails(), model);
        ViewBlueprintDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViewBlueprintDetails>): ViewBlueprintDetails {
        if (!model) return null;
        return ViewBlueprintDetails.newInstance(<ViewBlueprintDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViewBlueprintDetails) {
        if (!obj) return;

        models.ViewBlueprintDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViewBlueprintDetails): boolean {
        Object.setPrototypeOf(obj, ViewBlueprintDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resources) {
            for (let val of this.resources) {
                models.ResourcesDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Blueprint ID
     */
    id: string;

    /**
     * Blueprint Name
     */
    name: string;

    /**
     * Blueprints Description
     */
    description: string;

    /**
     * Resource Details
     */
    resources: Array<models.ResourcesDetails>;

    /**
     * Scope of the blueprint
     */
    scope: string;

    /**
     * Status of the blueprint
     */
    status: string;

    /**
     * Who has created the blueprint
     */
    created_by: string;

    /**
     * When was the blueprint created
     */
    created_at: string;

    /**
     * Who has updated the blueprint
     */
    updated_by: string;

    /**
     * When was the blueprint updated
     */
    updated_at: string;

}
